<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX942, CX943, CX944, XC9445, XC9455, XC9465 MFP-d">
     CX942, CX943, CX944, XC9445, XC9455, XC9465 MFP-d
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_et" title="Ohutusteave">
     Ohutusteave
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Kokkuleppet&auml;histused">
      Kokkuleppet&auml;histused
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="Toodet puudutavad teatised">
      Toodet puudutavad teatised
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_et" title="Printeri tundma&otilde;ppimine">
     Printeri tundma&otilde;ppimine
    </a>
   </p>
   <div id="divd0e170">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_et" title="Printeri kohta teabe leidmine">
      Printeri kohta teabe leidmine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_et" title="Printeri seerianumbri leidmine">
      Printeri seerianumbri leidmine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_et" title="Printeri konfiguratsioonid">
      Printeri konfiguratsioonid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_et" title="Juhtpaneeli kasutades">
      Juhtpaneeli kasutades
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_et" title="Indikaatortule olekute selgitus">
      Indikaatortule olekute selgitus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e560" title="Paberi valimine">
      Paberi valimine
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_et" title="Paigaldamine, seadistamine ja konfigureerimine">
     Paigaldamine, seadistamine ja konfigureerimine
    </a>
   </p>
   <div id="divd0e5309">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_et" title="Printeri paigalduskoha valimine">
      Printeri paigalduskoha valimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_et" title="Kaablite &uuml;hendamine">
      Kaablite &uuml;hendamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e5492" title="Seadistamine ja avakuva rakenduste kasutamine">
      Seadistamine ja avakuva rakenduste kasutamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e6013" title="Juurdep&auml;&auml;su funktsioonide seadistamine ja kasutamine">
      Juurdep&auml;&auml;su funktsioonide seadistamine ja kasutamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e6316" title="Printeri faksimiseks &uuml;lesseadmine">
      Printeri faksimiseks &uuml;lesseadmine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_et" title="E-posti SMTP seadete konfigureerimine">
      E-posti SMTP seadete konfigureerimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_et" title="Paberi ja eriprindimaterjalide laadimine">
      Paberi ja eriprindimaterjalide laadimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e8573" title="Tarkvara, draiverite ja p&uuml;sivara paigaldamine ja v&auml;rskendamine">
      Tarkvara, draiverite ja p&uuml;sivara paigaldamine ja v&auml;rskendamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-envelope-tray-topic.html#d0e8855" title="Lisariistvara paigaldamine">
      Lisariistvara paigaldamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="networking-intro-topic.html#d0e9833" title="V&otilde;rgu&uuml;henduste loomine">
      V&otilde;rgu&uuml;henduste loomine
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_et" title="Printeri turvamine">
     Printeri turvamine
    </a>
   </p>
   <div id="divd0e10222">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_et" title="Turvapesa asukoht">
      Turvapesa asukoht
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_et" title="Printeri m&auml;lu kustutamine">
      Printeri m&auml;lu kustutamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_et" title="Printeri salvestusseadme kustutamine">
      Printeri salvestusseadme kustutamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_et" title="Vaikeseadete taastamine">
      Vaikeseadete taastamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_et" title="H&auml;vivuse teatis">
      H&auml;vivuse teatis
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_et" title="Printimine">
     Printimine
    </a>
   </p>
   <div id="divd0e10414">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_et" title="Arvutist printimine">
      Arvutist printimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e10440" title="Mobiilseadmest printimine">
      Mobiilseadmest printimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-booklet-topic.html#printing-booklet_et" title="Bro&scaron;&uuml;&uuml;ri printimine">
      Bro&scaron;&uuml;&uuml;ri printimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_et" title="V&auml;lkm&auml;luseadmelt printimine">
      V&auml;lkm&auml;luseadmelt printimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_et" title="Toetatavad v&auml;lkm&auml;luseadmed ja failit&uuml;&uuml;bid">
      Toetatavad v&auml;lkm&auml;luseadmed ja failit&uuml;&uuml;bid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_et" title="Konfidentsiaalsete t&ouml;&ouml;de konfigureerimine">
      Konfidentsiaalsete t&ouml;&ouml;de konfigureerimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_et" title="Konfidentsiaalsete t&ouml;&ouml;de ja muude ootet&ouml;&ouml;de printimine">
      Konfidentsiaalsete t&ouml;&ouml;de ja muude ootet&ouml;&ouml;de printimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_et" title="Fondin&auml;idiste loendi printimine">
      Fondin&auml;idiste loendi printimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_et" title="Kataloogiloendi printimine">
      Kataloogiloendi printimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_et" title="Koopiate eraldamine eralduslehtedega">
      Koopiate eraldamine eralduslehtedega
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-printed-sheets-topic.html#stapling-printed-sheets_et" title="Prinditud lehtede klammerdamine">
      Prinditud lehtede klammerdamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_et" title="Prinditud lehtede mulgustamine">
      Prinditud lehtede mulgustamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="folding-printed-sheets-topic.html#folding-printed-sheets_et" title="Prinditud lehtede voltimine">
      Prinditud lehtede voltimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_et" title="Vahelehtede virnastuse kasutamine prinditud lehtede puhul">
      Vahelehtede virnastuse kasutamine prinditud lehtede puhul
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_et" title="Prindit&ouml;&ouml;st loobumine">
      Prindit&ouml;&ouml;st loobumine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_et" title="Tooneri tumeduse muutmine">
      Tooneri tumeduse muutmine
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_et" title="Kopeerimine">
     Kopeerimine
    </a>
   </p>
   <div id="divd0e11275">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_et" title="Automaatse dokumendis&ouml;&ouml;turi ja skanneriklaasi kasutamine">
      Automaatse dokumendis&ouml;&ouml;turi ja skanneriklaasi kasutamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_et" title="Kopeerimine">
      Kopeerimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_et" title="Fotode kopeerimine">
      Fotode kopeerimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_et" title="Kirjablanketile kopeerimine">
      Kirjablanketile kopeerimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_et" title="Kopeerige paberi m&otilde;lemale poolele">
      Kopeerige paberi m&otilde;lemale poolele
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_et" title="Koopiate suurendamine v&otilde;i v&auml;hendamine">
      Koopiate suurendamine v&otilde;i v&auml;hendamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_et" title="Printimine eksemplarhaaval">
      Printimine eksemplarhaaval
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_et" title="Koopiate eraldamine eralduslehtedega">
      Koopiate eraldamine eralduslehtedega
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_et" title="Mitme lehek&uuml;lje kopeerimine &uuml;hele sihtlehek&uuml;ljele">
      Mitme lehek&uuml;lje kopeerimine &uuml;hele sihtlehek&uuml;ljele
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_et" title="Kaartide kopeerimine">
      Kaartide kopeerimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-copies-topic.html#stapling-copies_et" title="Koopiate klammerdamine">
      Koopiate klammerdamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-copies-topic.html#punching-holes-copies_et" title="Koopiate mulgustamine">
      Koopiate mulgustamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-booklet-from-copied-documents-topic.html#creating-booklet-from-copied-documents_et" title="Bro&scaron;&uuml;&uuml;ri loomine kopeeritud dokumentidest">
      Bro&scaron;&uuml;&uuml;ri loomine kopeeritud dokumentidest
     </a>
    </p>
    <p class="toc-2-style">
     <a href="folding-copies-topic.html#folding-copies_et" title="Koopiate voltimine">
      Koopiate voltimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-copies-topic.html#using-offset-stacking-copies_et" title="Vahelehtede virnastamise kasutamine koopiate puhul">
      Vahelehtede virnastamise kasutamine koopiate puhul
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_et" title="Kopeerimise otsetee loomine">
      Kopeerimise otsetee loomine
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_et" title="E-post">
     E-post
    </a>
   </p>
   <div id="divd0e11705">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_et" title="Automaatse dokumendis&ouml;&ouml;turi ja skanneriklaasi kasutamine">
      Automaatse dokumendis&ouml;&ouml;turi ja skanneriklaasi kasutamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_et" title="E-kirja saatmine">
      E-kirja saatmine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_et" title="E-kirja saatmise otsetee loomine">
      E-kirja saatmise otsetee loomine
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_et" title="Faks">
     Faks
    </a>
   </p>
   <div id="divd0e11800">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_et" title="Automaatse dokumendis&ouml;&ouml;turi ja skanneriklaasi kasutamine">
      Automaatse dokumendis&ouml;&ouml;turi ja skanneriklaasi kasutamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_et" title="Faksi saatmine">
      Faksi saatmine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_et" title="Faksi saatmise ajastamine">
      Faksi saatmise ajastamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_et" title="Faksinumbri otsetee loomine">
      Faksinumbri otsetee loomine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_et" title="Faksi eraldusv&otilde;ime muutmine">
      Faksi eraldusv&otilde;ime muutmine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_et" title="Faksi tumeduse reguleerimine">
      Faksi tumeduse reguleerimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_et" title="Faksilogi printimine">
      Faksilogi printimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_et" title="R&auml;mpsfakside blokeerimine">
      R&auml;mpsfakside blokeerimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_et" title="Fakside kinnipidamine">
      Fakside kinnipidamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_et" title="Faksi edasisaatmine">
      Faksi edasisaatmine
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_et" title="Skannimine">
     Skannimine
    </a>
   </p>
   <div id="divd0e12164">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_et" title="Automaatse dokumendis&ouml;&ouml;turi ja skanneriklaasi kasutamine">
      Automaatse dokumendis&ouml;&ouml;turi ja skanneriklaasi kasutamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_et" title="Arvutisse skannimine">
      Arvutisse skannimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_et" title="Skannimine FTP-serverisse">
      Skannimine FTP-serverisse
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_et" title="FTP otsetee loomine">
      FTP otsetee loomine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_et" title="V&otilde;rgukausta skannimine">
      V&otilde;rgukausta skannimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_et" title="V&otilde;rgukausta otsetee loomine">
      V&otilde;rgukausta otsetee loomine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_et" title="Skannimine v&auml;lkm&auml;luseadmesse">
      Skannimine v&auml;lkm&auml;luseadmesse
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_et" title="Printeri men&uuml;&uuml;de kasutamine">
     Printeri men&uuml;&uuml;de kasutamine
    </a>
   </p>
   <div id="divd0e12466">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_et" title="Men&uuml;&uuml;kaart">
      Men&uuml;&uuml;kaart
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e12831" title="Seade">
      Seade
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e15395" title="Printimine">
      Printimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e16801" title="Paber">
      Paber
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e17144" title="Kopeerimine">
      Kopeerimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e17806" title="Faks">
      Faks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e20163" title="E-post">
      E-post
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e21213" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e21798" title="USB-m&auml;luseade">
      USB-m&auml;luseade
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e22656" title="V&otilde;rk/pordid">
      V&otilde;rk/pordid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e24837" title="Pilveteenused">
      Pilveteenused
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e24894" title="Turve">
      Turve
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e26083" title="Aruanded">
      Aruanded
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_et" title="Abi">
      Abi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_et" title="Veaotsing">
      Veaotsing
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_et" title="Men&uuml;&uuml;seadete lehe printimine">
      Men&uuml;&uuml;seadete lehe printimine
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_et" title="Printeri hooldamine">
     Printeri hooldamine
    </a>
   </p>
   <div id="divd0e26517">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_et" title="Osade ja tarvikute oleku kontrollimine">
      Osade ja tarvikute oleku kontrollimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_et" title="Tarvikute m&auml;rguannete seadistamine">
      Tarvikute m&auml;rguannete seadistamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_et" title="E-posti m&auml;rguannete seadistamine">
      E-posti m&auml;rguannete seadistamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_et" title="Aruannete vaatamine">
      Aruannete vaatamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_et" title="Osade ja tarvikute tellimine">
      Osade ja tarvikute tellimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e26797" title="Osade ja tarvikute asendamine">
      Osade ja tarvikute asendamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e27784" title="Printeri osade puhastamine">
      Printeri osade puhastamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e28085" title="Energia ja paberi s&auml;&auml;stmine">
      Energia ja paberi s&auml;&auml;stmine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_et" title="Printeri teisaldamine">
      Printeri teisaldamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_et" title="Printeri tarnimine">
      Printeri tarnimine
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_et" title="Probleemi veaotsing">
     Probleemi veaotsing
    </a>
   </p>
   <div id="divd0e28238">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_et" title="Prindikvaliteediga seotud probleemid">
      Prindikvaliteediga seotud probleemid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_et" title="Printeri veakoodid">
      Printeri veakoodid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_et" title="Printimisprobleemid">
      Printimisprobleemid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_et" title="Printer ei reageeri">
      Printer ei reageeri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_et" title="Ei loe v&auml;lkm&auml;luseadet">
      Ei loe v&auml;lkm&auml;luseadet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_et" title="USB-pordi lubamine">
      USB-pordi lubamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_et" title="Ummistuste likvideerimine">
      Ummistuste likvideerimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e32446" title="V&otilde;rgu&uuml;hendusega seotud probleemid">
      V&otilde;rgu&uuml;hendusega seotud probleemid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e32674" title="Lisariistvara probleemid">
      Lisariistvara probleemid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e32800" title="Tarvikutega seotud probleemid">
      Tarvikutega seotud probleemid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e32905" title="Paberis&ouml;&ouml;duga seotud probleemid">
      Paberis&ouml;&ouml;duga seotud probleemid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e33271" title="E-kirjade saatmisega seotud probleemid">
      E-kirjade saatmisega seotud probleemid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e33365" title="Faksimisprobleemid">
      Faksimisprobleemid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e34010" title="Skannimisprobleemid">
      Skannimisprobleemid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e34797" title="V&auml;rvikvaliteediga seotud probleemid">
      V&auml;rvikvaliteediga seotud probleemid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_et" title="Klienditeeninduse kontaktandmed">
      Klienditeeninduse kontaktandmed
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_et" title="Kustutamine ja h&auml;vitamine">
     Kustutamine ja h&auml;vitamine
    </a>
   </p>
   <div id="divd0e35047">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_et" title="Lexmarki toodete ringlusseviimine">
      Lexmarki toodete ringlusseviimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_et" title="Lexmarki pakendite ringlusseviimine">
      Lexmarki pakendite ringlusseviimine
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_et" title="Teatised">
     Teatised
    </a>
   </p>
   <div id="divd0e35082">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35085" title="Tooteteave">
      Tooteteave
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35102" title="Redaktsiooniteatis">
      Redaktsiooniteatis
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_et" title="Kaubam&auml;rgid">
      Kaubam&auml;rgid
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_et" title="Litsentsimise teated">
      Litsentsimise teated
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_et" title="M&uuml;ratasemed">
      M&uuml;ratasemed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_et" title="Elektroonikaromude (WEEE) direktiiv">
      Elektroonikaromude (WEEE) direktiiv
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35208" title="Liitium-ioon laetav aku">
      Liitium-ioon laetav aku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_et" title="M&auml;&auml;rus (EL) 2023/1542">
      M&auml;&auml;rus (EL) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35245" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_et" title="Toote kasutusest k&otilde;rvaldamine">
      Toote kasutusest k&otilde;rvaldamine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_et" title="Lexmarki kassettide tagastamine korduskasutamiseks v&otilde;i ringlussev&otilde;tmiseks">
      Lexmarki kassettide tagastamine korduskasutamiseks v&otilde;i ringlussev&otilde;tmiseks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_et" title="Staatilise tundlikkuse teatis">
      Staatilise tundlikkuse teatis
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_et" title="ENERGY STARi">
      ENERGY STARi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_et" title="Temperatuuriteave">
      Temperatuuriteave
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_et" title="Elektritarbimine">
      Elektritarbimine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_et" title="Telekommunikatsiooniv&otilde;rgu l&otilde;ppseadmeid puudutavad regulatiivsed teatised">
      Telekommunikatsiooniv&otilde;rgu l&otilde;ppseadmeid puudutavad regulatiivsed teatised
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_et" title="Vastavus Euroopa Liidu (EL) direktiividele">
      Vastavus Euroopa Liidu (EL) direktiividele
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_et" title="Raadiosideh&auml;irete teatis">
      Raadiosideh&auml;irete teatis
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue